import { SET_LOCALE } from './localeActionTypes';

export const setLocale = (locale: string) => ({
  meta: {
    locale,
  },
  type: SET_LOCALE,
});
